import { createFileRoute, redirect } from '@tanstack/react-router'
import { APITokensPage } from '../pages/APITokensPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/api-tokens' as any)({
    component: APITokensPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
